import { useCallback } from 'react';
import { useNavigate, type NavigateOptions } from 'react-router';

import { useOptionalDataSource } from '@/features/data/DataSourceContext';

import { withBase } from './paths';

/** `navigate('/deepdive-ai/abc')` with the current tree's base applied. */
export function useAppNavigate() {
  const navigate = useNavigate();
  const basePath = useOptionalDataSource()?.basePath ?? '';
  return useCallback(
    (to: string, options?: NavigateOptions) => navigate(withBase(basePath, to), options),
    [navigate, basePath],
  );
}
